import { isEqual } from 'lodash'
import { DependencyList, Dispatch, SetStateAction, useEffect, useState } from 'react'

export const useFilterValue = <T>(
  value: T,
  deps?: DependencyList,
  onChange?: () => void
): [T, Dispatch<SetStateAction<T>>] => {
  const [filterValue, setFilterValue] = useState<T>(value)

  useEffect(() => {
    if (!isEqual(value, filterValue)) {
      setFilterValue(value)
      onChange?.()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || [])])

  return [filterValue, setFilterValue]
}
